import { FaCode, FaMobile, FaSearch, FaBolt, FaShieldAlt, FaHandshake } from 'react-icons/fa';

export const webDevelopmentServiceData = {
  slug: 'web-development',
  title: 'Web Development Arizona | Custom Websites Phoenix Scottsdale Mesa',
  metaDescription: 'Professional web development services in Arizona. Custom websites, web applications, and e-commerce solutions for Phoenix, Scottsdale, and Mesa businesses. Free quote.',
  keywords: [
    'web development Arizona',
    'website development Phoenix',
    'custom web applications Arizona',
    'e-commerce development Phoenix',
    'responsive web design Arizona',
    'web developer Phoenix',
    'website design Arizona',
    'full stack developer Phoenix'
  ],
  
  hero: {
    title: 'Drive Results With Professional Web Development',
    subtitle: 'Custom websites and web applications built to convert visitors into customers and grow your Arizona business.',
    stats: [
      { number: '300%', label: 'Conversion Boost' },
      { number: '50%', label: 'Faster Loading' },
      { number: '24/7', label: 'Online Presence' }
    ]
  },

  whyChooseUs: {
    title: 'Why Choose Our Web Development Services',
    benefits: [
      {
        icon: <FaCode />,
        title: 'Custom Solutions',
        description: 'Tailored web applications built specifically for your business needs, not cookie-cutter templates. Every feature is designed to solve your unique challenges and support your specific business goals and processes.'
      },
      {
        icon: <FaMobile />,
        title: 'Mobile-First Design',
        description: 'Responsive websites that look perfect and function flawlessly on all devices and screen sizes. With 60% of traffic coming from mobile, your site will capture every potential customer regardless of how they find you.'
      },
      {
        icon: <FaSearch />,
        title: 'SEO Optimized',
        description: 'Built-in SEO best practices to help your website rank higher in Google and attract more customers. Clean code, fast loading, and proper structure give you a competitive advantage in search results.'
      },
      {
        icon: <FaBolt />,
        title: 'Lightning Fast',
        description: 'Optimized for speed with modern technologies ensuring fast loading times and great user experience. Studies show 1-second delays reduce conversions by 7% - we make sure you never lose a customer to slow loading.'
      },
      {
        icon: <FaShieldAlt />,
        title: 'Secure & Reliable',
        description: 'Enterprise-level security built into every website with regular updates, SSL certificates, and robust protection against threats. Your business and customer data stay safe with industry-standard security measures.'
      },
      {
        icon: <FaHandshake />,
        title: 'Ongoing Partnership',
        description: 'Comprehensive support beyond launch including regular updates, backups, monitoring, and feature enhancements. Your website evolves with your business through our long-term partnership approach.'
      }
    ]
  },

  process: {
    title: 'Our Web Development Process',
    description: 'From concept to launch, we follow a proven process that delivers exceptional web solutions.',
    steps: [
      {
        title: 'Strategy & Planning',
        description: 'Understand your goals, target audience, and technical requirements to create a comprehensive development strategy.'
      },
      {
        title: 'Design & Development',
        description: 'Create custom designs and develop your website using modern technologies and best practices.'
      },
      {
        title: 'Testing & Optimization',
        description: 'Rigorous testing across devices and browsers, performance optimization, and security hardening.'
      },
      {
        title: 'Launch & Support',
        description: 'Smooth deployment with ongoing maintenance, updates, and technical support to keep your site running perfectly.'
      }
    ]
  },

  technologies: {
    title: 'Web Technologies We Specialize In',
    items: [
      'React & Next.js',
      'JavaScript & TypeScript',
      'Node.js & Express',
      'Python & FastAPI',
      'PostgreSQL & MongoDB',
      'HTML5 & CSS3',
      'Tailwind CSS',
      'REST & GraphQL APIs',
      'WordPress Development',
      'E-commerce Platforms',
      'Progressive Web Apps'
    ]
  },

  results: {
    title: 'Web Development Results',
    items: [
      {
        metric: '300%',
        description: 'Average increase in online conversions'
      },
      {
        metric: '50%',
        description: 'Improvement in page loading speed'
      },
      {
        metric: '200%',
        description: 'Boost in search engine rankings'
      },
      {
        metric: '90%',
        description: 'Client satisfaction rate'
      }
    ]
  },

  faq: {
    title: 'Web Development FAQ',
    items: [
      {
        question: 'How long does it take to build a custom website?',
        answer: 'Timeline varies based on complexity. Simple business websites take 2-4 weeks, while complex web applications can take 6-12 weeks. We provide detailed timelines after understanding your specific requirements.'
      },
      {
        question: 'Do you build e-commerce websites?',
        answer: 'Yes, we specialize in custom e-commerce solutions using platforms like Shopify, WooCommerce, and custom solutions. We focus on conversion optimization and seamless user experience.'
      },
      {
        question: 'Will my website work on mobile devices?',
        answer: 'Absolutely! All our websites are built mobile-first and are fully responsive, ensuring perfect functionality and appearance across all devices and screen sizes.'
      },
      {
        question: 'Do you provide website maintenance?',
        answer: 'Yes, we offer comprehensive maintenance packages including security updates, content updates, performance monitoring, and technical support to keep your website running smoothly.'
      },
      {
        question: 'Can you help improve my existing website?',
        answer: 'Definitely! We provide website redesign, performance optimization, SEO improvements, and feature additions to enhance your existing web presence and boost results.'
      }
    ]
  },

  schema: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Web Development Services",
    "description": "Professional web development and custom website solutions for Arizona businesses",
    "provider": {
      "@type": "Person",
      "name": "Daniel Rangel",
      "telephone": "+1-480-282-0569",
      "email": "daniel@danielrayrangel.com"
    },
    "areaServed": {
      "@type": "State",
      "name": "Arizona"
    },
    "serviceType": "Web Development",
    "offers": {
      "@type": "Offer",
      "description": "Custom web development, website design, and web application development services"
    }
  }
};